/**
 * 移动端客户标签管理页
 */
import React, { useEffect, useState } from 'react';
import {
  List,
  PullToRefresh,
  Empty,
  Skeleton,
  Dialog,
  Button,
  Form,
  Input,
  Selector,
  Tag,
} from 'antd-mobile';
import { adminCustomerTagApi } from '../../api/index';
import Toast from 'antd-mobile/es/components/toast';

export default function MobileCustomerTagListPage() {
  const [loading, setLoading] = useState(true);
  const [tags, setTags] = useState([]);
  const [formModalVisible, setFormModalVisible] = useState(false);
  const [editingTag, setEditingTag] = useState(null);
  const [form] = Form.useForm();

  useEffect(() => {
    fetchTags();
  }, []);

  const fetchTags = async () => {
    try {
      const data = await adminCustomerTagApi.list();
      setTags(data || []);
    } catch (err) {
      Toast.show('获取标签列表失败');
    } finally {
      setLoading(false);
    }
  };

  const refreshData = async () => {
    await fetchTags();
  };

  const openForm = (tag) => {
    setEditingTag(tag);
    if (tag) {
      form.setFieldsValue({
        name: tag.name,
        color: tag.color || '#000000',
      });
    } else {
      form.resetFields();
    }
    setFormModalVisible(true);
  };

  const handleSubmit = async (values) => {
    try {
      if (editingTag) {
        await adminCustomerTagApi.update(editingTag.id, values);
        Toast.show('更新成功');
      } else {
        await adminCustomerTagApi.create(values);
        Toast.show('创建成功');
      }
      setFormModalVisible(false);
      fetchTags();
    } catch (err) {
      Toast.show(err?.response?.data?.message || '操作失败');
    }
  };

  const handleDelete = (id) => {
    Dialog.confirm({
      content: '确定要删除此标签吗？',
      onConfirm: async () => {
        try {
          await adminCustomerTagApi.delete(id);
          Toast.show('删除成功');
          fetchTags();
        } catch (err) {
          Toast.show(err?.response?.data?.message || '删除失败');
        }
      },
    });
  };

  const colorOptions = [
    { label: '金色 (VIP)', value: '#gold' },
    { label: '绿色 (新客户)', value: '#green' },
    { label: '蓝色 (潜在客户)', value: '#blue' },
    { label: '红色 (高风险)', value: '#red' },
    { label: '橙色', value: '#orange' },
    { label: '紫色', value: '#purple' },
    { label: '青色', value: '#cyan' },
    { label: '灰色', value: '#gray' },
  ];

  if (loading) {
    return (
      <div style={{ padding: 16 }}>
        <Skeleton.Title rows={3} />
        <Skeleton.Title rows={5} style={{ marginTop: 16 }} />
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', background: '#f5f5f5', padding: 16 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <h2 style={{ fontSize: 18, fontWeight: 600, margin: 0 }}>客户标签管理</h2>
        <Button size="small" color="primary" onClick={() => openForm(null)}>
          新建
        </Button>
      </div>

      <PullToRefresh onRefresh={refreshData}>
        {tags.length > 0 ? (
          <List>
            {tags.map((tag) => (
              <List.Item
                key={tag.id}
                style={{
                  background: '#fff',
                  marginBottom: 12,
                  padding: '12px 16px',
                }}
                description={
                  <div style={{ fontSize: 13, color: '#999', marginTop: 4 }}>
                    创建于 {tag.createdAt ? new Date(tag.createdAt).toLocaleString('zh-CN', { hour12: false }) : '-'}
                  </div>
                }
                extra={
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                    <span
                      style={{ fontSize: 13, color: '#1677ff', cursor: 'pointer' }}
                      onClick={() => openForm(tag)}
                    >
                      编辑
                    </span>
                    <span
                      style={{ fontSize: 13, color: '#ff4d4f', cursor: 'pointer' }}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDelete(tag.id);
                      }}
                    >
                      删除
                    </span>
                  </div>
                }
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <div style={{ fontSize: 15, fontWeight: 500 }}>{tag.name}</div>
                  <Tag color={tag.color?.replace('#', '') || 'default'} size="small">
                    预览
                  </Tag>
                </div>
              </List.Item>
            ))}
          </List>
        ) : (
          <div style={{ padding: '80px 0' }}>
            <Empty description="暂无标签" />
          </div>
        )}
      </PullToRefresh>

      {/* 新建/编辑弹窗 */}
      <Dialog
        visible={formModalVisible}
        style={{ '--content-width': '90%' }}
        content={
          <div style={{ padding: '16px 0' }}>
            <h3 style={{ fontSize: 16, fontWeight: 600, marginBottom: 16 }}>
              {editingTag ? '编辑标签' : '新建标签'}
            </h3>
            <Form
              form={form}
              layout="vertical"
              footer={
                <div style={{ display: 'flex', gap: 12, marginTop: 16 }}>
                  <Button block type="submit" color="primary" onClick={() => form.submit()}>
                    保存
                  </Button>
                  <Button block variant="outline" onClick={() => setFormModalVisible(false)}>
                    取消
                  </Button>
                </div>
              }
              onFinish={handleSubmit}
            >
              <Form.Item name="name" label="标签名称" rules={[{ required: true }]}>
                <Input placeholder="例：VIP、新客户" />
              </Form.Item>
              <Form.Item name="color" label="标签颜色" initialValue="#gold" rules={[{ required: true }]}>
                <Selector options={colorOptions} />
              </Form.Item>
            </Form>
          </div>
        }
        closeOnMaskClick={false}
      />
    </div>
  );
}
